import React from 'react';
import clsx from 'clsx';
import styles from './ButtonGroup.module.scss';

const ButtonGroup = ({ children }) => {
  const className = clsx(
    styles.ButtonGroup
  );

  return (
    <div className={className} role="group">
      {children}
    </div>
  );
};

export default ButtonGroup;
